export const ANALYSIS_TYPE = {
  SEGMENT: 4,
  TOP_MATERIAL: 5
}
export const TASK_STATUS = {
  // 无效
  INVALID: -1,
  // 未开始
  UNSTARTED: 0,
  // 生成中
  RUNNING: 1,
  // 已完成
  COMPLETED: 2,
  // 失败
  FAILED: 3,
  // 终止
  TERMINATED: 4
}

export const TASK_TYPE = {
  // 脚本创意
  SCRIPT_CREATIVE: 0,
  // 爆款复刻
  TOP_MATERIAL: 1
}

export const ANALYSIS_STATUS = {
  // 已拆解爆款
  POP_ANALYSIS_COMPLETED: 3,
  // 已分析片段
  EXTRA_SLICE_COMPLETED: 3
}

export const FONT_NAMES = ['思源黑体粗', '优设标题黑', 'Aa厚底黑', '创客贴金刚体', '阿里妈妈数黑体', 'Leefont蒙黑体']

export const INIT_SCRIPTS = [
  {
    name: '视觉爽感流（侧重吸量）',
    content: '请制作一条以视觉冲击力为核心的广告混剪，目标是通过极具爆发力的画面在短时间内抓住用户眼球。你需要从素材中优先挑选特效最华丽、战斗最激烈、或者有巨大Boss压迫感的片段，忽略那些平淡的跑图或复杂操作细节。剪辑逻辑上，请务必使用素材库中最炸裂的一个视觉瞬间作为开场（Hook），随后持续堆叠高光画面，保持高强度的节奏，让观众直观感受到游戏的刺激与爽快。'
  },
  {
    name: '玩法展示流（侧重留存）',
    content: '请制作一条以真实玩法展示为核心的广告混剪，目标是通过清晰的游戏逻辑和成长反馈建立用户信任。你需要从素材中优先挑选带有清晰UI交互（如装备合成、技能升级、抽卡反馈）以及完整战斗循环的片段，侧重展示从‘操作’到‘数值变强’的完整闭环。剪辑节奏需保持连贯，不要切得太碎，确保观众能看清界面上的关键数值变化，用真实的游玩过程激发玩家的尝试欲望。'
  },
  {
    name: '情怀怀旧流（侧重情感共鸣）',
    content: '请制作一条以怀旧情怀与经典复刻为核心的广告混剪，旨在直击80、90后玩家的童年记忆。你需要重点挖掘素材中那些极具辨识度的经典元素（如标志性的角色招式、复刻的街机关卡、选人界面或带有‘Insert Coin’暗示的画面），寻找能瞬间触发‘爷青回’感叹的瞬间。剪辑逻辑上，请营造一种‘时光倒流’或‘老友重聚’的氛围，强调手游版本对原版街机体验的1:1还原（原汁原味），用‘当年的游戏厅关门了，但这里的热血还在’的情感钩子，驱动老玩家下载重温旧梦。'
  }
]
